<template>
    <page>
        <module style="height: 550px;" ref="view">
            <module-tab title="特殊价申请" enable-flex style="width: 100%">
                <m-search ref="search" @search="searchHandle">
                    <c-form ref="searchForm">
                        <c-form-item type="select" label="管控类型" name="type" :options="type"></c-form-item>
                        <c-form-item type="input" label="申请单号" name="apply_number"></c-form-item>
                        <c-form-item type="select" label="审批状态" name="state" :options="state"></c-form-item>
                        <c-form-item type="select" label="启用状态" name="enable_state" :options="enableState"></c-form-item>
                        <c-form-item type="input" label="目标会员" name="user_info" placeholder="匹配昵称、手机号、会员名"></c-form-item>
                        <c-form-item type="input" label="指定商品" name="product_info" placeholder="匹配商品名称、货号"></c-form-item>
                        <c-form-item type="input" label="指定品牌" name="brand_info" placeholder="匹配品牌名称"></c-form-item>
                        <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>
                <m-operate>
                    <c-button color="sys" @click="navigateTo('/special_price_add')">申请特殊价格</c-button>
                </m-operate>
                <c-table ref="table">
                    <c-table-column
                            label="管控类型"
                            name="type"
                            width="80"
                    >
                        <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                        <template v-slot="{data}">
                            <span v-if="data.type == 1" style="color:blue">按商品</span>
                            <span v-if="data.type == 2" style="color:green">按品牌</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请单号"
                            name="apply_number"
                            width="140"
                    ></c-table-column>

                    <c-table-column
                            label="审批状态"
                            name="state"
                            width="80"
                    >
                        <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                        <template v-slot="{data}">
                            <span v-if="data.state == 0" style="color:#999"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == 1" style="color:blue"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == 2" style="color:green"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == -1" style="color:red"> {{stateText[data.state]}}</span>
                            <c-tooltip v-if="data.state == -1 && data.rejected_reason" :tip="data.rejected_reason" style="margin-left: 5px;"></c-tooltip>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="启用状态"
                            name="enable_state"
                            width="80"
                    >
                        <template v-slot="{data}">
                      <span v-if="data.state == 2">
                           <span v-if="data.enable_state == 0" style="color:red">禁用</span>
                           <span v-if="data.enable_state == 1" style="color:green">启用</span>
                       </span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="目标会员(部分)"
                            name="user_infos"
                            width="220"
                    >
                        <template v-slot="{data}">
                            <li v-for="(item, i) in data.user_infos.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;">{{item}}</li>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="关联商品(部分)"
                            name="product_infos"
                            width="220"
                    >
                        <template v-slot="{data}">
                        <span v-if="data.type == 1 && data.product_infos">
                          <li v-for="(item, i) in data.product_infos.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;">{{item}}</li>
                        </span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="关联品牌(部分)"
                            name="brand_infos"
                            width="120"
                    >
                        <template v-slot="{data}">
                        <span v-if="data.type == 2 && data.brand_infos">
                          <li v-for="(item, i) in data.brand_infos.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;">{{item}}</li>
                        </span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请时间"
                            name="create_date"
                            width="150"
                    ></c-table-column>

                    <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                            width="200"
                    >
                        <template v-slot="row">
                            <c-table-button power="m_special_price" @click="navigateTo(`/special_price_detail/${row.data.id}`)">查看</c-table-button>
                            <c-table-button power="b_special_price_edit" v-if="row.data.state == 2 && row.data.enable_state == 0" @click="editEnableState(row)">启用</c-table-button>
                            <c-table-button power="b_special_price_edit" v-if="row.data.state == 2 && row.data.enable_state == 1" @click="editEnableState(row)">禁用</c-table-button>
                            <c-table-button power="b_special_price_edit" v-if="(row.data.state == 0 || row.data.state == -1 || (row.data.state == 2 && row.data.enable_state == 0))" @click="navigateTo(`/special_price_edit/${row.data.id}`)">编辑</c-table-button>
                            <c-table-button power="b_special_price_edit" v-if="(row.data.state == 0 || row.data.state == -1 || (row.data.state == 2 && row.data.enable_state == 0))" @click="deleteInfo(row)">删除</c-table-button>
                            <c-table-button power="b_special_price_apply" v-if="row.data.state == 1" @click="navigateTo(`/special_price_verify/${row.data.id}`)">审核</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </module-tab>
            <module-tab title="特殊价查询" enable-flex style="width: 100%" onload="searchHandle2">
                <m-search ref="search2" @search="searchHandle2">
                    <c-form ref="searchForm">
                        <c-form-item type="select" label="管控类型" name="type" :options="type"></c-form-item>
                        <c-form-item type="input" label="申请单号" name="apply_number"></c-form-item>
                        <c-form-item type="select" label="审批状态" name="state" :options="state"></c-form-item>
                        <c-form-item type="select" label="启用状态" name="enable_state" :options="enableState"></c-form-item>
                        <c-form-item type="select" label="生效状态" name="effective_state" :options="effectiveState"></c-form-item>
                        <c-form-item type="input" label="代理手机号" name="user_manage_mobilephone" placeholder=""></c-form-item>
                        <c-form-item type="input" label="代理昵称" name="nick_name" placeholder=""></c-form-item>
                        <c-form-item type="input" label="指定商品" name="product_info" placeholder="匹配商品名称、货号"></c-form-item>
                        <c-form-item type="input" label="指定品牌" name="brand_info" placeholder="匹配品牌名称"></c-form-item>
                        <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>
                <m-operate>
                    <c-button color="m" hollow @click="syncExport()">导出</c-button>

                    <!--右侧通用菜单-->
                    <template #right>
                        <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">
                            编辑导出列
                        </c-button>
                    </template>
                </m-operate>
                <c-table ref="table2">
                    <c-table-column
                            label="管控类型"
                            name="type"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.type == 1" style="color:blue">按商品</span>
                            <span v-if="data.type == 2" style="color:green">按品牌</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请单号"
                            name="apply_number"
                            width="140"
                    ></c-table-column>

                    <c-table-column
                            label="审批状态"
                            name="state"
                            width="80"
                    >
                        <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                        <template v-slot="{data}">
                            <span v-if="data.state == 0" style="color:#999"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == 1" style="color:blue"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == 2" style="color:green"> {{stateText[data.state]}}</span>
                            <span v-if="data.state == -1" style="color:red"> {{stateText[data.state]}}</span>
                            <c-tooltip v-if="data.state == -1 && data.rejected_reason" :tip="data.rejected_reason" style="margin-left: 5px;"></c-tooltip>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="启用状态"
                            name="enable_state"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.state == 2">
                               <span v-if="data.enable_state == 0" style="color:red">禁用</span>
                               <span v-if="data.enable_state == 1" style="color:green">启用</span>
                            </span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="生效状态"
                            name="effective_state"
                            width="80"
                    >
                        <template v-slot="{data}">
                           <span v-if="data.effective_state == -1">--</span>
                           <span v-else-if="data.effective_state == 0" style="color:gray">未生效</span>
                           <span v-else-if="data.effective_state == 1" style="color:green">生效中</span>
                           <span v-else-if="data.effective_state == 2" style="color:red">已过期</span>
                           <span v-else-if="data.effective_state == 3" style="color:brown">已失效</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="生效时间 - 失效时间"
                            width="300"
                    >
                        <template v-slot="{data}">
                           <span>{{data.begin_time}} - {{data.end_time}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="代理手机号"
                            name="user_manage_mobilephone"
                            width="120"
                    ></c-table-column>

                    <c-table-column
                            label="代理头像/昵称"
                            name="head_photo"
                            width="120"
                    >
                        <template v-slot="{data}">
                            <div class="flex-center-cross">
                                <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                                <span>{{data.nick_name||'--'}}</span>
                            </div>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="特殊价商品/品牌"
                            width="200"
                    >
                        <template v-slot="{data}">
                            <div class="flex-center-cross">
                                <c-image :src="data.product_img_url" preview size="30" style="margin-right: 10px;"></c-image>
                                <span>{{data.product_name||'--'}}</span>
                            </div>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="减免方式"
                            width="100"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.preferential_type == 1">特殊折扣</span>
                            <span v-else-if="data.preferential_type == 2">直接减免</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="特殊价"
                            width="100"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.preferential_type == 1">
                                打<span style="color:red">{{((data.discount||0)*10).toFixed(0)}}</span>折
                            </span>
                            <span v-else-if="data.preferential_type == 2">
                                减免<span style="color:red">￥{{data.reduced_money}}</span>元
                            </span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请时间"
                            name="apply_date"
                            width="150"
                    ></c-table-column>
                </c-table>
            </module-tab>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'm_special_price',

        props: {
            apply_state: String
        },

        data() {
            return {
                workType:25,
                searchParams:{},
                state: [
                      {name: '草稿',value: '0'},
                      {name: '待审核',value: '1'},
                      {name: '审核通过',value: '2'},
                      {name: '驳回',value: '-1'}
                ],
                type: [
                      {name: '按商品',value: '1'},
                      {name: '按品牌',value: '2'}
                ],
                enableState: [
                      {name: '禁用',value: '0'},
                      {name: '启用',value: '1'}
                ],
                effectiveState: [
                      {name: '--',value: '-1'},
                      {name: '未生效',value: '0'},
                      {name: '生效中',value: '1'},
                      {name: '已过期',value: '2'},
                      {name: '已失效',value: '3'}
                ]
            }
        },

        computed: {
            ...mapState(['systemConfig', 'userInfo']),

            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            },

            defaultSearch() {
                let param = {
                    state: this.apply_state ? this.apply_state : '',
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
                this.$refs.search2.search();
            })
            this.$bus.$on('specialPriceList.update', () => {
                this.$refs.search.search();
                this.$refs.search2.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/special_price/list',
                    data
                });
            },
            searchHandle2(data) {
                this.$refs.table2.load({
                    url: '/special_price/detail/list',
                    data
                });
                this.searchParams = data;
            },
            /**删除特殊价申请**/
            deleteInfo(item) {
                this.$confirm({
                    text: '确定要删除特殊价格申请单【'+item.data.apply_number+'】？',
                    resolve: () => {
                        this.request({
                            url: '/special_price/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            /**特殊价申请启禁用**/
            editEnableState(item) {
                var enable_state = item.data.enable_state==0?1:0;
                var text = "";
                if (enable_state == 0){//禁用
                    text = '是否确定“禁用”特殊价申请单【'+item.data.apply_number+'】';
                }else {//启用
                    text = '启用后，之前生效的特殊价申请（关联相同会员、商品/品牌；且生效时间范围相同）将被本次申请数据覆盖,是否确定“启用”特殊价申请单【'+item.data.apply_number+'】';
                }
                this.$confirm({
                    text: text,
                    resolve: () => {
                        this.request({
                            url: '/special_price/edit/enable_state',
                            data: {
                                id: item.data.id,
                                enable_state: enable_state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: (enable_state==0?'【禁用】':'【启用】')+'成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                              this.$confirm({
                                text: msg,  // 提示内容,
                                buttonName: '知道了',  // 确定按钮文字
                                cancelButton: false  // 是否显示取消按钮
                              });
                              return false;
                            }
                        });
                    }
                });
            },
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
        }
    }
</script>